export default __webpack_public_path__ + "assets/910847.svg";